export default __webpack_public_path__ + "static/media/rent_on_time.721540b2.png";